import React, { useState, useEffect } from 'react';

const API_URL = "https://api.lii.com.co:5101";

const CalendarSection = () => {
  const [eventName, setEventName] = useState('');
  const [eventDate, setEventDate] = useState('');
  const [targetAmount, setTargetAmount] = useState('');
  const [events, setEvents] = useState([]);
  const [cagnottes, setCagnottes] = useState([]);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [creatingCagnotteFor, setCreatingCagnotteFor] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/events`)
      .then((res) => res.json())
      .then((data) => setEvents(Array.isArray(data) ? data : []))
      .catch((err) => console.error('Erreur lors du chargement des événements:', err));

    fetch(`${API_URL}/api/cagnottes`)
      .then((res) => res.json())
      .then((data) => setCagnottes(Array.isArray(data) ? data : []))
      .catch((err) => console.error('Erreur lors du chargement des cagnottes:', err));
  }, []);

  const handleAddEvent = async () => {
    if (!eventName || !eventDate) {
      alert('Please provide a name and select a date for the event.');
      return;
    }

    const newEvent = { name: eventName, date: eventDate };

    try {
      const response = await fetch(`${API_URL}/api/events`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newEvent),
      });

      if (!response.ok) throw new Error('Erreur lors de l’ajout de l’événement');

      const createdEvent = await response.json();
      setEvents([...events, createdEvent]);
      setEventName('');
      setEventDate('');
      setIsFormVisible(false);
    } catch (error) {
      console.error('Erreur dans handleAddEvent:', error.message);
    }
  };

  const handleDeleteEvent = async (id) => {
    try {
      const response = await fetch(`${API_URL}/api/events/${id}`, { method: 'DELETE' });

      if (!response.ok) throw new Error('Erreur lors de la suppression de l\'événement');

      setEvents(events.filter((event) => event._id !== id));
      setActiveMenu(null);
    } catch (error) {
      console.error('Erreur dans handleDeleteEvent:', error.message);
    }
  };

  const handleCreateCagnotte = async (eventId, eventName) => {
    if (!targetAmount || targetAmount <= 0) {
      alert("Please enter a valid target amount.");
      return;
    }

    const name = eventName; // La cagnotte porte le nom de l'événement

    try {
      const response = await fetch(`${API_URL}/api/cagnottes`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, targetAmount, eventId }),
      });

      if (!response.ok) throw new Error('Erreur lors de la création de la cagnotte');

      const newCagnotte = await response.json();

      // ✅ Ajoute immédiatement la cagnotte dans la section des cagnottes
      setCagnottes([...cagnottes, newCagnotte]);

      // ✅ Efface le champ de la cagnotte après ajout
      setCreatingCagnotteFor(null);
      setTargetAmount('');
      setActiveMenu(null);
    } catch (error) {
      console.error('Erreur dans handleCreateCagnotte:', error.message);
    }
  };

  const toggleMenu = (id) => {
    setActiveMenu(activeMenu === id ? null : id);
  };

  return (
    <div>
      <h2 className="text-lg font-bold mb-4">Événements</h2>
      <p className="text-gray-600 mb-4">Programmez les évènements à venir</p>

      <button
        onClick={() => setIsFormVisible(!isFormVisible)}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition duration-300 mb-4"
      >
        {isFormVisible ? 'Réduire' : 'Ajouter un événement'}
      </button>

      {isFormVisible && (
        <div className="mb-4">
          <input
            type="text"
            value={eventName}
            onChange={(e) => setEventName(e.target.value)}
            className="w-full p-2 mb-2 border rounded"
            placeholder="Entrez un nom d'événement"
          />
          <input
            type="date"
            value={eventDate}
            onChange={(e) => setEventDate(e.target.value)}
            className="w-full p-2 mb-2 border rounded"
          />
          <button
            onClick={handleAddEvent}
            className="w-full bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition duration-300"
          >
            Ajouter l'évènement
          </button>
        </div>
      )}

      {/* Liste des événements */}
      <div>
        {events.length === 0 ? (
          <p className="text-gray-500">Pas encore d'événement programmé</p>
        ) : (
          events.map((event) => (
            <div key={event._id} className="relative p-4 bg-gray-50 border rounded shadow mb-4">
              <h3 className="font-semibold">{event.name}</h3>
              <p className="text-gray-700">Date: {new Date(event.date).toLocaleDateString()}</p>

              {/* Menu contextuel */}
              <div className="absolute top-2 right-2">
                <button onClick={() => toggleMenu(event._id)}>...</button>
                {activeMenu === event._id && (
                  <div className="absolute right-0 bg-white border shadow rounded p-2">
<button
  onClick={() => handleDeleteEvent(event._id)}
  className="px-4 py-2 text-sm text-red-600 hover:bg-gray-100 cursor-pointer rounded-md"
>
  Delete Event
</button>                  </div>
                )}
              </div>

              {/* Formulaire de création de cagnotte */}
              {creatingCagnotteFor === event._id && (
                <div className="mt-4">
                  <input
                    type="number"
                    value={targetAmount}
                    onChange={(e) => setTargetAmount(e.target.value)}
                    className="w-full p-2 border rounded mb-2"
                    placeholder="Target Amount (€)"
                  />
                  <button
                    onClick={() => handleCreateCagnotte(event._id, event.name)}
                    className="w-full bg-purple-600 text-white px-6 py-2 rounded hover:bg-purple-700 transition duration-300"
                  >
                    Confirm Cagnotte
                  </button>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CalendarSection;